import React, {useEffect, useRef, useState} from "react";
import {useKeyPressEvent} from "react-use";
import {BsArrowReturnLeft} from "react-icons/bs";

interface EntitySearchItemProps<T> {
  item: T;
  renderDescription: (item: T) => React.ReactNode;
  onClick: () => void;
  focusedIndex: number;
  index: number;
}

export function EntitySearchItem<T>({
  renderDescription,
  onClick,
  focusedIndex,
  index,
  item,
}: EntitySearchItemProps<T>) {
  const itemRef = useRef<HTMLLIElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  const isFocused = focusedIndex === index;

  useEffect(() => {
    if (!isFocused || !itemRef.current) return;

    itemRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [isFocused]);

  useKeyPressEvent("Enter", () => {
    if (isFocused) {
      onClick();
    }
  });

  const backgroundColor =
    isFocused || isHovered ? "rgba(0, 0, 0, 0.05)" : "transparent";

  return (
    <li
      ref={itemRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      style={{
        listStyle: "none",
        padding: "12px",
        margin: 0,
        backgroundColor,
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {renderDescription(item)}
        </div>

        {isFocused && (
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <span style={{ fontSize: "0.75rem" }}>Enter</span>
            <BsArrowReturnLeft style={{ height: "12px", width: "12px" }} />
          </div>
        )}
      </div>
    </li>
  );
}
